module.exports = __webpack_public_path__ + "assets/link.9c719b73.svg";